itsoftApp.createModule("linksOnScroll", function () {
    const module = this;
    
    class ScrollTo {
        constructor(container) {
            this.container = container;
            this.selectors = container.querySelectorAll('.js-to-block');
            this.menu = container.querySelector('.js-to-block-row');
            this.outer = document.querySelector('.js-header-outer');
            this.speed = 500;
            this.blocks = [];
            this.block = null;
            this.blockOffest = null;
            this.blockHeight = null;
            this.curBlock = null;
            this.curLink = null;
            this.layer = null;
    
            this.init();
        }

        setLinkToBlock() {
            this.checkLayer();
            ScrollTo.resetOldLink();
    
            this.blocks.forEach((el) => {
                this.curBlock = document.querySelector(`#${el}`);
    
                if (this.curBlock) {
                    this.curLink = document.querySelector(`.js-to-block[href="#${el}"]`);
                    this.blockOffest = this.getOffset(this.curBlock).top;
                    this.blockHeight = this.curBlock.clientHeight;
                    if (this.isBlockInWindow) {
                        this.curLink.classList.add('_active');
                        this.scrollMenuHor();
                    }
                }
            });
        }

        getOffset(el) {
            const rect = el.getBoundingClientRect();
            const scrollLeft = window.scrollX;
            const scrollTop = window.scrollY;
            return {
                top: rect.top + scrollTop,
                left: rect.left + scrollLeft,
            };
        }
    
        scrollMenuHor() {
            if (ScrollTo.tabletSize && this.menu) {
                this.menu.scrollLeft = this.curLink.offsetLeft - 4;
            }
        }
    
        checkLayer() {
            this.layer = this.outer ? this.outer.clientHeight : 0;
            if (ScrollTo.tabletSize && this.menu) {
                this.layer += this.menu.clientHeight;
            }
        }
    
        pushBlocks() {
            this.selectors.forEach((el) => {
                const block = el.hasAttribute('data-href') ? 
                    el.dataset.href.replace('#', '') :
                        el.getAttribute('href').replace('#', '');

                if (block !== '' && (this.blocks.indexOf(block) === -1)) {
                    this.blocks.push(block);
                }
            });
        }
    
        addListeners() {
            itsoftApp.modules.windowScroll.addEvent(this.setLinkToBlock);
            itsoftApp.modules.windowResize.addEvent(this.setLinkToBlock);
        }
    
        get isBlockInWindow() {
            return this.positionBlock.top && this.positionBlock.bottom;
        }
    
        get positionBlock() {
            return {
                top: window.scrollY + this.layer + 1 >= this.blockOffest,
                bottom: window.scrollY + this.layer < this.blockOffest + this.blockHeight - 1,
            };
        }
    
        static get tabletSize() {
            return window.innerWidth < 1024;
        }
    
        static resetOldLink() {
            const oldCurLinks = document.querySelectorAll('.js-to-block._active');
    
            if (oldCurLinks.length > 0) {
                oldCurLinks.forEach((el) => el.classList.remove('_active'));
            }
        }
    
        init() {
            this.setLinkToBlock = this.setLinkToBlock.bind(this);
            // this.getOffset = this.getOffset.bind(this);
            this.pushBlocks();
            this.addListeners();
            this.setLinkToBlock();
        }
    }

    
    module.callback = ScrollTo;
});


